import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Zap, Trophy, Check, Lock, Mail, Shield, RefreshCw } from 'lucide-react';
const pack = {
  id: 'megapack',
  icon: <Zap className="text-blue-600" data-id="element-139" />,
  title: 'MEGAPACK QUÍMICA VISUAL™ EDICIÓN LATAM',
  subtitle: 'Todo lo que necesitas para organizar, explicar, practicar y evaluar química en secundaria.',
  savings: 'OFERTA ESPECIAL DE LANZAMIENTO',
  features: ['✅ 5 cuadernillos completos', '✅ Más de 600 páginas', '✅ Más de 150 fichas visuales', '✅ Más de 200 actividades', '✅ Actividades con formatos A y B', '✅ Rúbricas y criterios de evaluación', '✅ Guías de laboratorio', '✅ Proyectos integradores', '✅ Historietas científicas', '✅ Documentos completos y fichas individuales', '✅ Acceso digital inmediato', '✅ Garantía de satisfacción de 7 días'],
  oldPrice: 'USD 49',
  price: 'USD 16',
  url: 'https://quimica-visual-secundaria.impultienda.ar/checkout'
};
export function Pricing() {
  const handlePurchase = () => {
    window.location.href = pack.url;
  };
  return <section id="pricing" className="py-2 md:py-12 px-4 max-w-4xl mx-auto min-h-[100dvh] flex flex-col justify-center" data-id="element-140">
      <div className="text-center mb-2 md:mb-10" data-id="element-141">
        <h2 className="text-xl md:text-5xl font-black text-slate-900 mb-1 md:mb-4" data-id="element-142">
          ¿Cuánto tiempo quieres recuperar este año?
        </h2>
        <p className="text-slate-600 font-bold text-[10px] md:text-lg" data-id="element-143">
          Una sola oferta de lanzamiento. Acceso digital inmediato.
        </p>
      </div>

      <div className="space-y-2 md:space-y-4 mb-4 md:mb-8" data-id="element-144">
        <motion.div className="p-3 md:p-8 rounded-2xl md:rounded-3xl border-2 border-blue-600 bg-white shadow-xl shadow-blue-900/10 relative overflow-hidden" data-id="element-145">
          <div className="flex items-start gap-3 md:gap-4" data-id="element-146">
            <div className="flex-1" data-id="element-147">
              <div className="flex flex-wrap gap-1 md:gap-2 mb-1 md:mb-3" data-id="element-148">
                <span className="bg-green-500 text-white text-[7px] md:text-[10px] font-black px-1.5 py-0.5 rounded-full uppercase tracking-widest" data-id="element-149">
                  {pack.savings}
                </span>
              </div>
              <div className="flex items-center gap-1.5 md:gap-2 mb-0.5 md:mb-1" data-id="element-150">
                <span className="scale-75 md:scale-100 origin-left" data-id="element-151">
                  {pack.icon}
                </span>
                <h3 className="font-black text-slate-900 text-[11px] md:text-xl uppercase leading-tight" data-id="element-152">
                  {pack.title}
                </h3>
              </div>
              <p className="text-slate-500 font-bold text-[9px] md:text-sm mb-1 md:mb-4" data-id="element-153">
                {pack.subtitle}
              </p>
              <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} className="space-y-1 md:space-y-2 mb-2 md:mb-6" data-id="element-154">
                {pack.features.map((f, i) => <div key={i} className="flex items-start gap-1.5 text-[9px] md:text-base text-slate-700 font-medium leading-tight" data-id="element-155">
                    {!f.startsWith('✅') && <Check size={12} className="text-blue-600 shrink-0 mt-0.5 md:w-4 md:h-4" data-id="element-156" />}
                    <span data-id="element-157">{f}</span>
                  </div>)}
              </motion.div>
              <div className="flex items-baseline gap-2 md:gap-3" data-id="element-158">
                <span className="text-slate-400 line-through font-bold text-[10px] md:text-lg" data-id="element-159">
                  {pack.oldPrice}
                </span>
                <span className="md:text-4xl font-black text-slate-900 text-[24px]" data-id="element-160">
                  {pack.price}
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>

      {/* PRE-CHECKOUT: Payment Info */}
      <div className="text-center mb-3 md:mb-4" data-id="element-161">
        <h3 className="text-slate-900 font-black text-sm md:text-base mb-2" data-id="element-162">
          PAGO SEGURO Y PROTEGIDO
        </h3>
        <p className="text-slate-600 font-medium text-xs md:text-sm mb-1 max-w-2xl mx-auto" data-id="element-163">
          🔒 Compra segura. Precio expresado en USD. En el checkout verás la
          conversión automática a tu moneda local. Una vez confirmado el pago,
          recibirás el material digital por correo electrónico.
        </p>
      </div>

      {/* DELIVERY BADGE */}

      <motion.button animate={{
      boxShadow: ['0 0 15px rgba(34,197,94,0.2)', '0 0 30px rgba(34,197,94,0.5)', '0 0 15px rgba(34,197,94,0.2)'],
      scale: [1, 1.03, 1]
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} onClick={handlePurchase} className="w-full bg-[#16A34A] hover:bg-green-700 text-white font-black md:text-3xl py-4 md:py-6 rounded-2xl md:rounded-3xl shadow-xl shadow-green-900/20 mb-2 md:mb-3 uppercase tracking-tight text-[16px]" data-id="element-164">
        DESCARGAR EL MATERIAL AHORA
      </motion.button>

      {/* REDIRECT MICRO-TEXT */}
      <p className="text-center text-slate-500 text-[10px] md:text-xs font-medium mb-2 md:mb-3" data-id="element-165">
        Serás redirigido a una pasarela de pago segura y protegida.
      </p>

      {/* WARRANTY REINFORCEMENT */}
      <div className="flex items-start justify-center gap-2 text-center mb-4 md:mb-8 px-2" data-id="element-166">
        <Shield size={14} className="text-slate-600 shrink-0 mt-0.5" data-id="element-167" />
        <p className="text-slate-600 text-[11px] md:text-xs font-medium leading-snug" data-id="element-168">
          <span className="font-bold" data-id="element-169">Compra protegida y garantizada.</span> Si
          no estás conforme, tienes 7 días para pedir la devolución total de tu
          dinero.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-4 mb-4 md:mb-12 mt-4 md:mt-16" data-id="element-170">
        {[{
        icon: <Lock data-id="element-171" />,
        title: 'PAGO PROTEGIDO',
        desc: 'Pasarela de pago segura'
      }, {
        icon: <Mail data-id="element-172" />,
        title: 'ACCESO INMEDIATO',
        desc: 'Entrega digital por correo electrónico'
      }, {
        icon: <Shield data-id="element-173" />,
        title: 'GARANTÍA DE 7 DÍAS',
        desc: 'Compra sin riesgo'
      }, {
        icon: <RefreshCw data-id="element-174" />,
        title: 'CONVERSIÓN AUTOMÁTICA',
        desc: 'Pago en tu moneda local desde el checkout'
      }].map((badge, i) => <div key={i} className="bg-white p-6 rounded-3xl border border-blue-50 text-center flex flex-col items-center" data-id="element-175">
            <div className="text-blue-600 mb-3" data-id="element-176">{badge.icon}</div>
            <p className="font-black text-slate-900 text-xs md:text-sm mb-1" data-id="element-177">
              {badge.title}
            </p>
            <p className="text-slate-400 text-[10px] md:text-xs font-bold" data-id="element-178">
              {badge.desc}
            </p>
          </div>)}
      </div>

      <div className="bg-white p-8 rounded-[2.5rem] border border-blue-100 flex flex-col md:flex-row items-center gap-6 text-center md:text-left" data-id="element-179">
        <div className="shrink-0" data-id="element-180">
          <img src="https://cdn.magicpatterns.com/uploads/wPdBTd5Jo7F4dpjLi12DAp/garantia-7-dias-250.webp" alt="Garantía 7 días" className="w-24 h-auto md:w-32" data-id="element-181" />
        </div>
        <div data-id="element-182">
          <h5 className="text-slate-900 font-black text-lg md:text-xl mb-1" data-id="element-183">
            Garantía de satisfacción de 7 días
          </h5>
          <p className="text-slate-500 font-medium text-sm md:text-base" data-id="element-184">
            Explora el material con tranquilidad. Si consideras que no es
            adecuado para tus necesidades, puedes solicitar la devolución dentro
            de los 7 días posteriores a la compra, de acuerdo con las
            condiciones de garantía.
          </p>
        </div>
      </div>
    </section>;
}